import React, { FC, useCallback, useMemo } from 'react';
import styled from 'styled-components';
import { useSelector } from 'react-redux';
import { Paper } from '@material-ui/core';
import EventXtraBranding from './EventXtraBranding';
import useEventBrandingUrl from './useEventBrandingUrl';

const EventXtraBrandingContainer = styled(Paper)<{ backgroundcolor: string }>`
  padding: 4px;
  margin-bottom: 32px;
  max-width: 80%;
  background-color: ${({ backgroundcolor }) => (backgroundcolor || 'rgba(0, 0, 0, 0.7)')};
`;

const footerClassName = 'footer-v2-container';

const FooterV2: FC<{
  hashState?: string;
  className?: string;
}> = ({ hashState, className }: {
  hashState?: string;
  className?: string;
}) => {
  const { featuresToggle, footer } = useSelector((s) => s.eventConfigs);
  const brandingUrl = useEventBrandingUrl(hashState);

  const footerBackgroundColor = footer?.backgroundColor;

  const resolvedClassName = useMemo(() => [footerClassName, className].join(' '), [className]);

  const footerOnClick = useCallback(() => {
    window.trackingEventToFirebase(null, 'Footer_Click', '', '');
  }, []);

  if (featuresToggle.removeFooter) return null;
  return (
    <EventXtraBrandingContainer
      backgroundcolor={footerBackgroundColor}
      className={resolvedClassName}
      onClick={footerOnClick}
      elevation={4}
    >
      <EventXtraBranding url={brandingUrl} />
    </EventXtraBrandingContainer>
  );
};

export default FooterV2;
